import { setToken, setPerson } from "./loginSlice";
import { setCurrentStakeholder } from "../stakeholder/stakeholderSlice";
import * as loginService from "../../../services/Login";

export const fetchToken = (body) => async (dispatch) => {
  try {
    // FAKE STATIC BODY

    // TATO
    // const body = { id: "6718dbec3e40a1a6f44fe218" };
    // DSX
    // const body = { id: "655f63eca99de1ee5dc2bfff" };
    // ECOLOGY
    // const body = { id: "655f6379884b3130c0433a13" }
    // FHN
    // const body = { id: "658184ad556fff649d7ee0c0" }
    // NATIONAL PARK
    // const body = { id: "65818695d8809ba9209c7c52" }

    const resp = await loginService.login(body);

    sessionStorage.setItem("token", resp.data.token);
    const currentStakeholder = { ...resp.data.stakeholder };

    delete currentStakeholder.person;
    delete currentStakeholder.gradeApp;
    dispatch(setToken(resp?.data?.token));
    dispatch(setCurrentStakeholder(currentStakeholder));
    dispatch(setPerson(resp?.data?.stakeholder?.person));
    document.cookie = `token=${resp.data.token}; path=/`;
    localStorage.setItem(
      "currentStakeholder",
      JSON.stringify(currentStakeholder)
    );
    return resp;
  } catch (err) {
    throw err;
  }
};
